// extracted by mini-css-extract-plugin
export default {"Blueberry":"#3E3AC2","Bluecheese":"#615CFF","body":"G8c1bfe Gb6cc27 G0932ba Gee1693","bottom":"Gbf2e62","link":"G2788ad"};